/* lg-collection-desc-mobile.js - Block 82 (4 Sep). On mobile the collection
   description drops below the product grid so the products are the first thing
   under the title.

   The description is .collection-hero__description.rte
   (sections/main-collection-banner.liquid:37). The banner title is a separate
   element and stays put - it is the page H1 in the normal case.

   Original position is remembered as (parent, nextSibling) rather than an
   index, so restoring is exact even if siblings changed. Nodes are moved, never
   cloned, so listeners and lazy-loading inside the description survive. */
(function () {
  'use strict';

  if (window.lgCollectionDescMobile) return; // double-bind guard
  window.lgCollectionDescMobile = true;

  // Block 90 (9 Sep): 989, was 749. Everything below 990 now uses the mobile
  // collection treatment - drawer button, no sidebar, description under the
  // grid - so the width at which this moves the description has to match the
  // width at which the sidebar goes away, or the description would sit above a
  // full-width grid on a tablet and below it on a phone.
  var BREAKPOINT = 989;
  var MOVED = 'lg-collection-desc--moved';

  function init() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc) return; // no description on this collection: nothing to do

    // Safety net: never move a block that carries an h1. The banner title is
    // the page h1 now, and main-collection-banner.liquid rewrites any <h1> in
    // the description to <h3>, so this should not fire - but if either changes,
    // the heading stays above the grid rather than dropping below it.
    if (desc.querySelector('h1')) return;

    // Prefer landing after the pagination when there is one, so the description
    // sits below the whole listing rather than between grid and pager.
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var pager = grid.querySelector('.pagination-wrapper');
    var anchor = pager || grid;

    var homeParent = desc.parentNode;
    var homeNext = desc.nextSibling;
    var moved = false;

    function apply() {
      var small = window.innerWidth <= BREAKPOINT;
      if (small && !moved) {
        if (anchor.parentNode) {
          anchor.parentNode.insertBefore(desc, anchor.nextSibling);
          desc.classList.add(MOVED);
          moved = true;
        }
      } else if (!small && moved) {
        homeParent.insertBefore(desc, homeNext);
        desc.classList.remove(MOVED);
        moved = false;
      }
    }

    apply();

    var scheduled = false;
    window.addEventListener('resize', function () {
      if (scheduled) return; // one pass per frame; apply() is a no-op unless the side changed
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; apply(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
